import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-958a62b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MiaodouRule" }
const _hoisted_2 = { class: "use" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, "苗豆有哪些用途？")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "use" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "text" }, "苗豆会过期吗？")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "苗豆会过期，平台即将推出苗豆商城，可使用苗豆进行商品置换/消费抵扣。")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VanImage, {
      src: require("@/assets/img/miaodou_rule.png"),
      width: "100%",
      height: "100%",
      fit: "cover",
      radius: "4px"
    }, null, 8, ["src"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.useList, (item, index) => {
          return (_openBlock(), _createElementBlock("li", null, _toDisplayString(item), 1))
        }), 256))
      ])
    ]),
    _hoisted_4
  ]))
}